import 'intersection-observer';
import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store/store';
// import plugin
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css';
//leaflet css
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import '@mdi/font/css/materialdesignicons.min.css';
import 'typeface-roboto/index.css';
// Google Analytics
import VueGtag from 'vue-gtag';
//particles
import VueParticles from 'vue-particles';

Vue.use(VueParticles);
import authentication from '@/plugins/authentication';

Vue.use(authentication);

import Util from '@/mixins/util';

import i18n from './i18n';

//fixes issue with marker not being visible
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.config.productionTip = false;

// use this package's plugin
Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi',
});

Vue.use(
  VueGtag,
  {
    config: {
      id: 'G-H94151MZQK',
      params: {
        send_page_view: false,
      },
    },
  },
  router,
);

Vue.$keycloak.onAuthSuccess = () => {
  let res_data_obj = {};
  res_data_obj.access_token = Vue.$keycloak.token;
  res_data_obj.refresh_token = Vue.$keycloak.refreshToken;
  Util.methods.setLocalStorage(res_data_obj);
};

Vue.$keycloak.onAuthRefreshSuccess = () => {
  let res_data_obj = {};
  res_data_obj.access_token = Vue.$keycloak.token;
  res_data_obj.refresh_token = Vue.$keycloak.refreshToken;
  Util.methods.setLocalStorage(res_data_obj);
};

Vue.$keycloak.onTokenExpired = () => {
  Vue.$keycloak
    .updateToken()
    .then(refreshed => {
      if (refreshed) {
        console.debug('Token was successfully refreshed');
      } else {
        console.debug('Token is still valid');
      }
    })
    .catch(err => {
      Util.methods.logout();
      console.error(err);
    });
};

Vue.$keycloak.onAuthError = () => {
  console.log('onAuthError');
  Util.methods.clearLocalStorage();
  location.reload();
};

Vue.$keycloak.onAuthRefreshError = () => {
  console.log('onAuthRefreshError');
  Util.methods.clearLocalStorage();
};

let refreshToken = null;
let token = null;
try {
  if (localStorage.refresh_token) {
    if (Util.methods.isTokenExpired(localStorage.refresh_token)) {
      console.log('Token is expired');
      Util.methods.clearLocalStorage();
    } else {
      refreshToken = localStorage.refresh_token;
      token = localStorage.token;
    }
  }
} catch (error) {
  console.error(error);
  // expected output: ReferenceError: nonExistentFunction is not defined
  // Note - error messages will vary depending on browser
}

Vue.$keycloak.init({ checkLoginIframe: false, token, refreshToken }).then(() => {
  console.log('init app');
  new Vue({
    i18n,
    vuetify,
    router,
    store: store,
    beforeCreate() {
      this.$store.commit('initialiseStore');
    },
    render: h => h(App),
  }).$mount('#app');
});

import './styles/app.scss';
